export default {
    page_title: "Temporary Reopening",
    filter_recently_modified: "Recently Modified",
    search_placeholder: "name, email or CNP",
    delete_exceptions_text: "Do you want to delete exceptions?",
    btn: {
        add_reopening: "Temporary Reopening",
        delete_exceptions: "Delete Exceptions",
    },
    table: {
        beneficiary_list: "Beneficiary List",
        beneficiary_name: "Name",
        beneficiary_phone: "Phone",
        beneficiary_email: "Email",
        beneficiary_cnp: "CNP",
        beneficiary_status: "Status",
        beneficiary_recently_modified: "Recently Modified",
        select_company_first: "Select a company first",
        select_company_hint: "To view users, please select a company first",
        no_recently_modified: 'No',
        recently_modified: 'yes',
        temporary_ignore_timesheet: 'Extend Timesheet',
        status_1: 'Active',
        status_2: 'Invited',
        status_3: 'Suspended',
        status_4: 'Pending Deletion',
    },
    modal: {
        header_text: "You have selected the following users.",
        header_text1: "Carefully review your selection and set the date until which the platform remains open for them.",
        expiry_date_label: "Access Expiry Date",
        select_date_time: "Select Date",
        info_text: "After this date, accounts will return to the default setting.",
        btn_reopen: "Reopen Platform",
        ignore_timesheet_label: "Do you want reopening for UpDejun as well",
        validation: {
            future_date: "The date must be in the future",
            date_required: "The date is required.",
            no_user: "Please select at least one user.",
        }
    },
    toast: {
        success_message: "Platform has been successfully reopened for the selected users!",
        error_message: "An error occurred. Please try again.",
        delete_success: "Exceptions have been successfully deleted",
    },
    one_user_selected: "{count} user selected",
    few_users_selected: "{count} users selected",
    many_users_selected: "{count} users selected",
    clear_selection: "Clear Selection",
}